import { PublicNav } from "@/components/PublicNav";

const UPDATED = "July 2026";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen bg-stone-50">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 lg:px-8 pt-28 pb-20">
        <h1 className="font-heading text-4xl font-semibold tracking-tight text-stone-900">{title}</h1>
        <p className="text-sm text-stone-500 mt-2">Last updated: {UPDATED}</p>
        <div className="prose prose-stone mt-8 space-y-5 text-stone-700 leading-relaxed">{children}</div>
        <p className="text-xs text-stone-400 mt-10">This document is provided for general information and is not legal advice. Please consult a qualified attorney to ensure compliance for your organization.</p>
      </section>
    </div>
  );
}

const H = ({ children }) => <h2 className="font-heading text-xl font-medium text-stone-900 mt-8">{children}</h2>;

export function Terms() {
  return (
    <Shell title="Terms of Service">
      <p>Welcome to Gather. By accessing or using our platform, you agree to these Terms of Service. Gather connects grocery stores, aid organizations, donors, and people in need to reduce waste and meet community needs.</p>
      <H>Accounts</H>
      <p>Grocery stores and aid organizations must register for an account and provide accurate information. Aid organizations are reviewed and verified by Gather before appearing publicly. You are responsible for maintaining the confidentiality of your login credentials.</p>
      <H>Subscriptions & payments</H>
      <p>Grocery store subscriptions are billed at $499/month and processed securely through Stripe. Individuals in need and donors use Gather free of charge and without an account. All charges are shown before you confirm payment.</p>
      <H>Donations</H>
      <p>Donor payments and subscription proceeds are directed to benefit Partnership to End Addiction. Gather absorbs payment-processing fees separately. Donations are non-refundable except where required by law.</p>
      <H>Acceptable use</H>
      <p>You agree not to misuse the platform, post false listings or requests, or impersonate any organization. Gather may suspend or remove accounts and content that violate these terms or endanger vulnerable users.</p>
      <H>Disclaimers</H>
      <p>Aid resources shown on the map are aggregated from public data sources and partner organizations and are provided "as is" without warranty of accuracy or availability. Always confirm details directly with the organization.</p>
      <H>Contact</H>
      <p>Questions about these terms? Reach us through the contact options on our site.</p>
    </Shell>
  );
}

export function Privacy() {
  return (
    <Shell title="Privacy Policy">
      <p>Gather respects your privacy. This policy explains what we collect and how we use it.</p>
      <H>Information we collect</H>
      <p>For grocery stores and aid organizations: account details such as organization name, email, phone, and address. For people in need submitting a request: the name or nickname and item you provide (no account or email required). For donors: only the information needed to process a payment, handled by Stripe.</p>
      <H>How we use it</H>
      <p>We use your information to operate the platform: matching surplus food to nearby organizations, alerting organizations by in-app notification, email, and SMS, coordinating pickups, and processing payments.</p>
      <H>Payments</H>
      <p>Payments are processed by Stripe. Gather does not store your full card details. Please review Stripe's privacy policy for how they handle payment data.</p>
      <H>Sharing</H>
      <p>We do not sell your personal information. Limited details are shared only as needed to fulfill a request (for example, a requester's chosen name is shared with the partner organization handling the pickup).</p>
      <H>Your choices</H>
      <p>Account holders can update their information or delete their account at any time from their dashboard. Deleting your account removes your account and associated listings or wishlist items.</p>
      <H>Contact</H>
      <p>For privacy questions, reach us through the contact options on our site.</p>
    </Shell>
  );
}
